import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import AddTerritoryModal from "./Components/AddTerritoryModal";
import AddTerritoryTown from "./Components/AddTerritoryTownModal";

type Props = {};

function MyTerritoryTown({}: Props) {
  const [isOpenModalTown, setIsModalOpenTown] = useState(false);
  const [modalStatus, setModalStatus] = useState("");

  const toggle = () => {
    setIsModalOpenTown(!isOpenModalTown);
  };

  const handleAddTerritoryTowns = () => {
    setModalStatus("Add");
    setIsModalOpenTown(true);
  };

  const handleEditTerritories = () => {
    setModalStatus("Edit");
    setIsModalOpenTown(true);
    console.log("EDIT TERRITORIES");
  };

  const handleSubmit = () => {
    // setModalStatus("Add");
    // setIsModalOpen(true);
    alert("Submit!");
    setIsModalOpenTown(!isOpenModalTown);
  };

  return (
    <div className="container mt-3">
      <PageHeader
        title="My Territories & Towns"
        buttons={[
          {
            label: "+ Add Territory Towns",
            onClick: () => handleAddTerritoryTowns(),
            color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Territories & Towns"
        data={announcementData || []}
        columns={MyTerritoryTownColumns(handleEditTerritories)}
      />

      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isOpenModalTown}
        title={
          modalStatus === "Add" ? "Add Territory Town" : "Edit Territory Town"
        }
        content={
          <>
            <AddTerritoryTown
              handleSubmit={handleSubmit}
              toggle={toggle}
              modalStatus={modalStatus}
            />
          </>
        }
      />
    </div>
  );
}

export default MyTerritoryTown;

const MyTerritoryTownColumns = (handleEditTerritories: (row: any) => void) => [
  {
    name: "Employee Name",
    selector: (row: { employeename: string }) =>
      row.employeename ? row.employeename : "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Designation",
    selector: (row: { designation: string }) => row.designation ?? "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Head Quarter Location",
    selector: (row: { HQL: string }) => row.HQL ?? "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Created",
    selector: (row: { created: string }) => row.created || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Submitted",
    selector: (row: { submitted: string }) => row.submitted || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Approved",
    selector: (row: { approved: string }) => row.approved || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Rejected",
    selector: (row: { rejected: string }) => row.rejected || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Processed",
    selector: (row: { processed: string }) => row.processed || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Actions",
    width: "200px",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleEditTerritories(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          Edit
        </button>
      </>
    ),
  },
];

const announcementData = [
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
];
